import React from 'react'

const CardBlock = () => {
  return (
  <> 
  
   <div className="mx-auto max-w-4xl px-3 py-8">
              <div
                className="flex flex-col-reverse items-center md:bg-[#EFF6FF] bg-white border border-white rounded-[14px] md:flex-row"
                style={{ boxShadow: "0px 1px 4px 0px rgba(0, 0, 0, 0.15)" }}
              >
                <img
                  className="object-cover md:w-auto w-full"
                  src="../src/assets/images/toloveit.png"
                  alt=""
                />
                <div className="md:px-7 px-0">
                  <div className="flex flex-col justify-between p-4 leading-normal">
                    <p className="mb-4 text-[20px] font-normal text-[#233751] text-start">
                      Two capsules just before bed is all you need to get the
                      best sleep of your life…
                    </p>
                    <p className="mb-4 text-[20px] font-normal text-[#233751] text-start">
                      So you can{" "}
                      <span className="bold-font text-[#233751]">
                        “feel like yourself again”.
                      </span>
                    </p>
                    <p className="text-[20px] font-normal text-[#233751] text-start">
                      This is hands down my favorite all-natural sleep aid I’ve
                      <span className="bold-font text-[#233751]"> EVER </span>
                      tried.
                    </p>
                  </div>
                </div>
              </div>
            </div>
  </>
  )
}

export default CardBlock